<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <div class="tbl-scroll-host">
      <el-table :data="list" v-loading="listLoading" highlight-current-row row-key="Id"
        @select="dialogCheck" @row-click="selectCurrentRow"
        ref="table" class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="TimeName" label="时间名称" show-overflow-tooltip></el-table-column>
        <el-table-column label="校区" width="120">
          <template slot-scope="scope">{{ scope.row.CampusId ? (scope.row.CampusName || '—') : '全校' }}</template>
        </el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">{{ scope.row.StartTime }} ~ {{ scope.row.EndTime }}</template>
        </el-table-column>
        <el-table-column prop="SortOrder" label="排序" width=""></el-table-column>
        <el-table-column label="状态" width="">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsEnable ? 'success' : 'danger'">
              {{ scope.row.IsEnable ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" width="160"></el-table-column>
      </el-table>
      </div>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="pageSize" :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <el-dialog :title="formTitle" :visible.sync="formVisible" :close-on-click-modal="false" width="450px" destroy-on-close>
        <el-form :model="editForm" label-width="90px" :rules="formRules" ref="editForm">
          <el-form-item label="时间名称" prop="TimeName">
            <el-input v-model="editForm.TimeName" placeholder="如：早自习、晚自习"></el-input>
          </el-form-item>
          <el-form-item label="所属校区">
            <el-select v-model="editForm.CampusId" placeholder="全校通用" style="width:100%">
              <el-option label="全校通用" :value="0" />
              <el-option v-for="c in campusOptions" :key="c.Id" :label="c.Name" :value="c.Id" />
            </el-select>
          </el-form-item>
          <el-form-item label="时间" prop="StartTime">
            <el-time-picker is-range v-model="mainRange"
              start-placeholder="开始" end-placeholder="结束"
              format="HH:mm" value-format="HH:mm"
              @change="onMainRangeChange" style="width:100%">
            </el-time-picker>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item label="备注">
            <el-input v-model="editForm.Remark" type="textarea" :rows="2" placeholder="备注说明"></el-input>
          </el-form-item>
          <el-form-item label="排序号">
            <el-input-number v-model="editForm.SortOrder" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="是否启用">
            <el-switch v-model="editForm.IsEnable" active-text="启用" inactive-text="禁用"></el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button type="primary" @click="formSubmit" :loading="formLoading">提交</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import { getSpecialCourseTimeList, saveSpecialCourseTime, deleteSpecialCourseTime } from '../../api/modules/schedule-course';
import { getCampusList } from '../../api/modules/misc';
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'
import { normalizeDeptId } from '../../utils/deptCascaderProps'

const defaultForm = () => ({
  Id: 0,
  DepartmentId: 0,
  CampusId: 0,
  TimeName: '',
  StartTime: '',
  EndTime: '',
  Remark: '',
  SortOrder: 0,
  IsEnable: true
})

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      departmentId: 0,
      campusOptions: [],
      filters: { timeName: '', isEnable: null, campusId: null },
      searchList: [
        { label: '名称', key: 'timeName', width: '150px', initValue: '' },
        {
          label: '选择校区', key: 'campusId', type: 'select', width: '180px', clearable: true, initValue: null,
          options: []
        },
        {
          label: '状态', key: 'isEnable', type: 'select', width: '120px', clearable: true, initValue: null,
          options: [{ label: '启用', value: true }, { label: '禁用', value: false }]
        }
      ],
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      buttonList: [],
      currentRow: null,

      formVisible: false,
      formTitle: '新增时间配置',
      formLoading: false,
      editForm: defaultForm(),
      mainRange: ['', ''],
      formRules: {
        TimeName: [{ required: true, message: '请输入时间名称', trigger: 'blur' }],
        StartTime: [{ validator: (r, v, cb) => { this.editForm.StartTime ? cb() : cb(new Error('请选择时间段')) }, trigger: 'change' }]
      }
    }
  },
  methods: {
    treeNodeClick(data) {
      this.departmentId = data.value
      this.page = 1
      this.filters.campusId = null
      this.loadCampusOptions()
      this.$nextTick(() => {
        if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
          this.$refs.toolbar.searchObj.campusId = null
        }
        this.handleQuery()
      })
    },
    loadCampusOptions() {
      if (!this.departmentId) {
        this.campusOptions = []
        const campusSearch = this.searchList.find(e => e.key === 'campusId')
        if (campusSearch) campusSearch.options = []
        return
      }
      getCampusList({ page: 1, intPageSize: 999, departmentId: this.departmentId }).then(res => {
        const r = res.data || res
        this.campusOptions = (r.success && r.response && r.response.data) ? r.response.data : []
        const campusSearch = this.searchList.find(e => e.key === 'campusId')
        if (campusSearch) {
          campusSearch.options = this.campusOptions.map(e => ({
            label: e.Name,
            value: e.Id
          }))
        }
      })
    },
    handleCurrentChange(val) {
      this.page = val
      this.handleQuery()
    },
    handleQuery() {
      if (!this.departmentId) {
        this.$message.error('请先从左侧选择具体的机构/学校')
        return
      }
      this.listLoading = true
      const { campusId: filterCampus, ...restFilters } = this.filters
      const params = { departmentId: this.departmentId, page: this.page, pageSize: this.pageSize, ...restFilters }
      const campusId = normalizeDeptId(filterCampus)
      if (campusId) params.campusId = campusId
      getSpecialCourseTimeList(params)
        .then(res => {
          const result = res.data || res
          if (result.success) {
            this.list = result.response.data
            this.total = result.response.dataCount
          }
        })
        .finally(() => { this.listLoading = false })
    },
    callFunction(item) {
      if (typeof item.search === 'object') {
        this.filters = Object.assign({ timeName: '', isEnable: null, campusId: null }, item.search)
      } else {
        this.filters = { timeName: item.search, isEnable: null, campusId: null }
      }
      this[item.Func] && this[item.Func](item)
    },
    /** 勾选列：单选。clearSelection 需放到 nextTick，避免与 Element 内部选中态打架导致点了不亮。 */
    dialogCheck(selection, row) {
      if (!row) return
      const keep = Array.isArray(selection) && selection.some(r => r && r.Id === row.Id)
      this.$nextTick(() => {
        if (!this.$refs.table) return
        this.$refs.table.clearSelection()
        if (keep) {
          this.currentRow = row
          this.$refs.table.toggleRowSelection(row, true)
          this.$refs.table.setCurrentRow(row)
        } else {
          this.currentRow = null
          this.$refs.table.setCurrentRow(null)
        }
      })
    },
    /** 点击行即可选中（勾选 + 高亮），便于工具栏编辑/删除。 */
    selectCurrentRow(val) {
      if (!val) return
      this.currentRow = val
      this.$nextTick(() => {
        if (!this.$refs.table) return
        this.$refs.table.clearSelection()
        this.$refs.table.toggleRowSelection(val, true)
        this.$refs.table.setCurrentRow(val)
      })
    },
    onMainRangeChange(val) {
      if (!val) return
      this.editForm.StartTime = val[0] || ''
      this.editForm.EndTime = val[1] || ''
    },
    handleAdd() {
      if (!this.departmentId) { this.$message.error('请先选择机构/学校'); return }
      this.formTitle = '新增时间配置'
      this.editForm = defaultForm()
      this.editForm.DepartmentId = this.departmentId
      this.mainRange = ['', '']
      this.formVisible = true
      this.$nextTick(() => { this.$refs.editForm && this.$refs.editForm.clearValidate() })
    },
    handleEdit() {
      if (!this.currentRow) { this.$message.error('请先选择一行数据'); return }
      this.formTitle = '编辑时间配置'
      this.editForm = Object.assign(defaultForm(), this.currentRow)
      this.mainRange = [this.editForm.StartTime || '', this.editForm.EndTime || '']
      this.formVisible = true
      this.$nextTick(() => { this.$refs.editForm && this.$refs.editForm.clearValidate() })
    },
    handleDel() {
      if (!this.currentRow) { this.$message.error('请先选择要删除的数据'); return }
      this.$confirm('确认删除该时间配置吗？', '提示', { type: 'warning' }).then(() => {
        this.listLoading = true
        deleteSpecialCourseTime({ id: this.currentRow.Id }).then(res => {
          const result = res.data || res
          if (result.success) {
            this.$message.success('删除成功')
            this.handleQuery()
          } else {
            this.$message.error(result.msg)
          }
          this.listLoading = false
        })
      })
    },
    formSubmit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        this.formLoading = true
        saveSpecialCourseTime(this.editForm).then(res => {
          const result = res.data || res
          if (result.success) {
            this.$message.success('保存成功')
            this.formVisible = false
            this.handleQuery()
          } else {
            this.$message.error(result.msg)
          }
          this.formLoading = false
        })
      })
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
  }
}
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox { display: none; }
</style>
